import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import getContract, {getAutoRunContract} from '../services/contract';
import { ethers } from "ethers";
import Modal from './modal'; // importing the Modal component

import useCss from "../helpers/useCss";
const materialize = "/home/css/materialize.css";
const bootstrap = "/home/css/bootstrap.css";
const styleCss = "/css/style.css";

const Home = () => {
  useCss('stylesheet', materialize);
  useCss('stylesheet', bootstrap);
  // useCss('stylesheet', styleCss);

  let [totalValue, setTotalValue] = useState(0);
  let [totalMembers, setTotalMembers] = useState(0);


  useEffect(() => {
    async function getData() {
      try {
        const contract = await getContract();
        const autorunContract = await getAutoRunContract();
        setTotalMembers(ethers.BigNumber.from(await contract.lastIDCount()).toNumber());

        const valueInvestedBN = await contract.totalValueInvested();
        const autorunTotalInvestedBN = await autorunContract.totalValueInvested();
        const totalInvested = +ethers.utils.formatUnits(valueInvestedBN, "mwei");
        const autorunTotalInvested = +ethers.utils.formatUnits(autorunTotalInvestedBN, "mwei");
        setTotalValue(totalInvested+autorunTotalInvested);
      } catch (error) {
        console.log(error);
        // alert('Switch Network to Polygon chain');
      }
    }
    getData();
  }, []);

  return (
    <>
      <div className="wrapper" id="top">
        <header className="header" style={{ padding: "0px" }}>
          <div className="header-wrap"></div>
        </header>
        <div 
          // style={{ background: "url('/logo/bg-b.jpg')"}} 
          style={{ backgroundColor: "#000000"}}
          className="midd-container">
          <div
            className="hero-main platinum-layout white-sec"
            style={{ backgroundImage: "url(/logo/bg3.jpeg)" }}
            // style={{ background: "url('/logo/bg-b.jpg')"}}
          >
            <div className="container">
              <div className="row align-items-center">
                
                <div className="col-sm-12 col-md-12 mobile-center text-center">
                  <div className="image-container flex justify-center mb-2">
                    <img style={{width: "400px"}} src="/logo/TBIGIF.gif" className="" />
                  </div>
                  {/* <div className="w-20">
                    <span className="d-inline">
                      <img src="/logo/MATIC.png" width="100%" className="logo d-inline" />
                      <h2 className="d-inline">Brilliant X Chain</h2>
                    </span>
                  </div> */}
                  <h1 style={{ fontWeight: "bolder", fontSize: "40px" }}>
                   <span style={{ color: "#FFCC33"}} >TOP BUSINESS INFINITY</span>{" "} <span style={{ color: "#FDFBF7"}} >DeFi</span>{" "}
                    {/* <span>Smart Contract</span> */}
                  </h1>
                  
                  <div
                    className="hero-btns heading-content__btns flex justify-center text-center"
                    style={{ paddingTop: "55px" }}
                  >
                    <div className="btn-wrap text-center">
                      <a
                        href="/join"
                        className="def-btn m text-center def-blue login__button"
                        style={{
                          whiteSpace: "nowrap",
                          background: "black",
                          border: "dotted",
                          // display: "inline-block",
                          // minWidth: "300px",
                          height: "80px",
                          fontSize: "30px",
                          // lineHeight: "50px",
                        }}
                      >
                        REGISTER
                      </a>
                    </div>
                    <div className="btn-wrap text-center">
                      <a
                        href="/login"
                        className="def-btn text-center def-blue login__button"
                        style={{
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          background: "black",
                          border: "dotted",
                          // display: "inline-block",
                          // minWidth: "300px",
                          height: "80px",
                          fontSize: "30px",
                          // color: "white"
                          // lineHeight: "50px",
                        }}
                      >
                        SIGN IN{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="advantages-number" style={{ zIndex: 99, backgroundColor: "#000000" }}>
            <div className="advantages-number-wrap total-stat flex" id="total-stat">
              <div className="advantages-number__item revealator-zoomin revealator-once revealator-within">
                <div className="advantages-number__item-title">Total<br /> Accounts</div>
                <div className="advantages-number__item-content">
                  <nobr>{totalMembers}</nobr>
                </div>
              </div>
              
              <div className="advantages-number__item revealator-zoomin revealator-once revealator-within">
                <div className="advantages-number__item-title">Total<br /> Earned</div>
                <div className="advantages-number__item-content">
                  <nobr>{totalValue}</nobr> USDT
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <div className="" style={{
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                backgroundImage: "url('/logo/bg8.jpg')",
                width: "100%",
                borderTop: "8px solid #fbbd18",
              }}>
              <div className="container mt-5">
                <div className="flex justify-center items-center text-center">
                  <div className="advantages-number__item-content">
                    <nobr style={{fontSize: "40px" }} className="">How It Works</nobr>
                  </div>
                </div>
                <div className="row">
                  
                  <div className="col-md-12">
                    <div
                      className="panel-group"
                      id="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree10"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree10"
                              aria-expanded="false"
                              aria-controls="collapseThree10"
                            >
                              WHAT IS DECENTRALIZATION?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree10"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree10"
                        >
                          <div className="panel-body">
                            <p>
                              The process works based on distributing authority
                              from a centralized administration to the
                              participants involved in the process. Unlike a
                              centralized system, all decisions are made by
                              consensus.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree5"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree5"
                              aria-expanded="false"
                              aria-controls="collapseThree5"
                            >
                              WHICH WALLET SHOULD I USE?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree5"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree5"
                        >
                          <div className="panel-body">
                            <p>
                              Top Business Infinity works with all crypto wallets. When working
                              with TBI: - for all types of EVM wallets like
                              Metamask and Trust Wallet. These wallets are among
                              the most popular and demanded in the global crypto
                              industry.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingOne"
                        >
                          <h4 className="panel-title">
                            <a
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              WHAT IS INFINITY XGOLD MATRIX?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseOne"
                          className="panel-collapse collapse in"
                          role="tabpanel"
                          aria-labelledby="headingOne"
                        >
                          <div className="panel-body">
                            <p>
                              Infinity xGold is (BLOCKCHAIN BASED) 2x2 up to 4 levels Matrix of TOP BUSINESS INFINITY (Defi) which is developed on Polygon Blockchain.
                              it has up to 4 Ranks of <span style={{ color: "#ffc107" }}>2, 10, 50, 250 USDT</span> respectively and has Rank AutoUpgrade functionality to upgrade your Rank automatically when others join under your downline. <br />
                              In 4th downline the last 2 joinings is the Re-Cycle of your tree for Rank 1-4. <br />
                              Information about transactions in the Polygon network can always be viewed at the link
                              https://polygonscan.com
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree20"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree20"
                              aria-expanded="false"
                              aria-controls="collapseThree20"
                            >
                              WHAT IS RE-CYCLE (RE-INVEST) IN XGOLD?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree20"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree20"
                        >
                          <div className="panel-body">
                            <p>
                              After 30 ids placed below you then you will be re-placed in your sponser tree in free place this is called Re-cycle.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree21"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree21"
                              aria-expanded="false"
                              aria-controls="collapseThree21"
                            >
                              WHAT ARE "OVERFLOWS" AND "OVERTAKES"?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree21"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree21"
                        >
                          <div className="panel-body">
                            <p>
                              Overflows are when vacant places in your sites are
                              filled with partners who were not invited by you.
                              They can come from both an upstream partner and a
                              downstream partner. <br /> 
                              Overtaking is a situation when
                              your partner does not have a Rank that his
                              partner activates and the transaction is sent
                              along the chain to you, provided that you have
                              this Rank active. This partner follows you and
                              brings you income until his superior partner
                              activates the missing Rank.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingTwo"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              INFINITY XGOLD PAYOUT SYSTEM
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseTwo"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingTwo"
                        >
                          <div className="panel-body">
                            <p>
                            Infinity xGold Levels Payouts for each RANK are as below: <br />
                            <span style={{ color: "#ffc107" }}> - Multi Payout (upto 15 Sponsers) (15%) <br/> - First Downline (5%) <br/> - Second Downline (5%) <br/>- Third Downline (25%) <br/>- Fourth Downline (50%) <br/></span>
                            Your 4th downline payout has first 4 placements of PartnerRewards hold (must have atleast 2 partners to get income), AutoUpgrade hold (explained below), and last 2 placements for Re-Cycle hold.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree"
                              aria-expanded="false"
                              aria-controls="collapseThree"
                            >
                              HOW AUTOUPGRADE WORKS?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree"
                        >
                          <div className="panel-body">
                            <p>
                              <span style={{ color: "#ffc107" }}>For Rank 1-3,</span> inside your tree in 4th downline level after 4 joinings (users) the next 10 payouts (500%) will be locked for you if you dont have next Rank purchased.
                              <br />
                              <span style={{ color: "#ffc107" }}>For Rank 4,</span> inside your tree in 4th downline level after 9 joinings (users) the next 5 payouts (250%) will be locked for you to purchase OR re-purchase AutoRun Matrix.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree2"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree2"
                              aria-expanded="false"
                              aria-controls="collapseThree2"
                            >
                              HOW AUTORUN INFINITY WORKS?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree2"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree2"
                        >
                          <div className="panel-body">
                            <p>
                              AutoRun Infinity as name tells is an INFINITE matrix 2x2 upto INFINITE levels, 
                              and its SMART CONTRACT has capability of storing millions of users inside tree and on POLYGON BLOCKCHAIN with efficiency (less fee). <br />
                              The tree fills with a principle of <span style={{ color: "#ffc107" }}>first come first serve rule,</span> but you must be eligible to join it <span style={{ color: "#ffc107" }}>(must be Rank 4)</span>. <br />
                              After 30 ids placed below you then you will <span style={{ color: "#ffc107" }}>RE-BORN</span> again in this INFINITE MATRIX. <br /> <br />
                              {/* <span style={{ color: "#ffc107" }}>Payout System</span> */}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree3"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree3"
                              aria-expanded="false"
                              aria-controls="collapseThree3"
                            >
                              AUTORUN INFINITY PAYOUT SYSTEM
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree3"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree3"
                        >
                          <div className="panel-body">
                            <p>
                              AutoRun Infinity Levels Payouts are as below: <br />
                              <span style={{ color: "#ffc107" }}> - First Downline (10%) <br/> - Second Downline (10%) <br/>- Third Downline (30%) <br/>- Fourth Downline (50%) <br/></span>
                              Your 4th downline last 4 placements payment will be holded for your 2 RE-BORNS below next available free user in QUEUE.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree4"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree4"
                              aria-expanded="false"
                              aria-controls="collapseThree4"
                            >
                              WHAT IS QUEUE IN AUTORUN? (ALGORITHM TECHNICALITY)
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree4"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree4"
                        >
                          <div className="panel-body">
                            <p>
                              If you join AutoRun then your id will be placed in an INFINITE QUEUE, lets say it inserted after ID1 (you sit below ID1), 
                              so after ID1's both downlines filled it is your turn with respect to QUEUE. <br /> 
                              So next 2 joining will be under you. And if you re-purchase AutoRun then you will be inserted again in the QUEUE.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree5"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree11"
                              aria-expanded="false"
                              aria-controls="collapseThree11"
                            >
                              REPURCHASING AUTORUN CRITERIA?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree11"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree11"
                        >
                          <div className="panel-body">
                            <p>
                              You can manually purchase autorun 1 time on RANK 4 and 1 time it will be auto-purchased for you per cycle. <span style={{ color: "#ffc107" }}>(TOTAL 2 times per cycle)</span> <br />
                              On RANK 4 after any cycle completes it will be automatically re-purchased for you if you dont want to buy manually.
                            </p>
                          </div>

                          </div>
                          <div className="panel panel-default">
                        <div
                          className="panel-heading"
                          role="tab"
                          id="headingThree12"
                        >
                          <h4 className="panel-title">
                            <a
                              className="collapsed"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree12"
                              aria-expanded="false"
                              aria-controls="collapseThree12"
                            >
                              What is TBI Loan?
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapseThree12"
                          className="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="headingThree12"
                        >
                          <div className="panel-body">
                            <p>
                              TBI Loan is the process of Lending to invest in Autorun Matrix <span style={{ color: "#ffc107" }}>(Lending Lot = 500 USDT)</span> <br />
                              Any wallets in Rank4 can borrow from Lenders who put funds in dashboard. Income of Borrower since completed lending will pay directly to lender until all funds achieved amount, after that the next income will change to pay to borrower, more details, please join the communities.
                            </p>
                          </div>
                          </div>  
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clear"></div>
        <footer style={{zIndex: "1000" }} className="diamond-footer">
          <div className="footer-widget-area">
            <div className="container">
              <div className="row">
                <div className="col-lg-3 col-md-4 widget-area logo_clear_first">
                  <div
                    className="widget widget-html"
                    style={{ paddingTop: "30px" }}
                  >
                    {/* <div className="footer-logo">
                      <img
                        src="/logo/BX.png"
                        style={{ width: '100px', paddingBottom: "30px", marginTop: "-20px" }}
                      />
                      <span style={{ fontSize: "15px" }}>
                        Copyright © 2023. All Rights Reserved
                      </span>
                    </div> */}
                  </div>
                </div>
                <div className="col-lg-6 col-md-4 widget-area">
                  <div className="widget widget-html text-center">
                    <h2 className="widget-title">Social Media</h2>
                    <div className="socials">
                      <ul>
                        {/* <li>
                          <a target="_blank" href="https://www.facebook.com/sxm2023">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href="https://twitter.com/sxm2023">
                            <i className="fab fa-twitter"></i>
                          </a>
                        </li> */}
                        <li>
                          <a target="_blank" href="https://t.me/tbi_2024">
                            <i className="fab fa-telegram-plane"></i>
                          </a>
                        </li>

                        {/* <li>
                          <a target="_blank" href="https://www.youtube.com/@sxm2023">
                            <i className="fab fa-youtube"></i>
                          </a>
                        </li> */}

                      </ul>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Home;


// useScript(jqueryScript);
  // useScript(carausalScript);
  // useScript(jqueryFancyScript, true);
  // useScript(revealatorJs, true);
  // useScript(circleProgress);
  // useScript(bootstrapScript);
  // useScript(onPageScroll);
  // useScript(wow);
  // useScript(jqueryCountdown);
  // useScript(owlScript);
  // useScript(slickScript);
  // useScript(particles);
